import { render, staticRenderFns } from "./ScanView.vue?vue&type=template&id=24a443b8"
import script from "./ScanView.vue?vue&type=script&lang=js"
export * from "./ScanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports